<template>
  <div style="background: rgb(242, 242, 245);">
    <div style="display: flex; background: #1A1A1A; justify-content: center;">
      <top-menu />
    </div>
    <div style="display: flex; justify-content: center;">
      <support-content />
    </div>
    <home-footer />
  </div>
</template>

<script>
import TopMenu from '../TopMenu';
import supportContent from './content';
import homeFooter from './BottomFooter.vue';

export default {
  components: {
    supportContent,
    homeFooter,
    TopMenu
  },
  created() {},
  methods: {
    onClick() {
      this.$router.push('/profile');
    }
  }
};
</script>

<style lang="less" scoped>
h1 {
  font-size: 1rem;
  padding: 20px;
  text-align: center;
}
</style>
